import { refreshAccessToken } from "./apiClient";
import { API_URL } from "./constant";

// initate payment
async function attempInitiatePayment(data,token) {
    const response = await fetch(`${API_URL}/payments/stripe/create_payment_intent/`,{
        method:'POST',
        headers:{
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(data)
    })

    const responseData = await response.json();

    if(!response.ok){
        const err = new Error("Failed to initiate payment intent");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// main function to create the stripe intent
export async function createPaymentIntent(data) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try{
        return await attempInitiatePayment(data,accessToken)
    }catch(error){
        if (error.status === 401){
            try{
                const newAccessToken = await refreshAccessToken();
                return await attempInitiatePayment(data, newAccessToken);
            }catch(refreshError){
                console.log("Token refresh failed",refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error while initiating the payment intent",error?.data || error.message);
        throw error;
    }
}

// pay transaction history
export async function attemptGetTransactionHistory(page,page_size,token,searchTerm,fromDate,toDate,orgFilter) {
    const params = new URLSearchParams({
        page,
        page_size
    })
    console.log(fromDate)
    if (searchTerm) params.append('search',searchTerm)
    if (fromDate) params.append('from_date',fromDate)
    if (toDate) params.append('to_date',toDate)
    if (orgFilter) params.append('org',orgFilter)
    
    const response = await fetch(`${API_URL}/payments/pay_transaction/?${params.toString()}`,{
        method:"GET",
        headers:{
            'Authorization': `Bearer ${token}`,
        }
    })

    const responseData = await response.json();

    if(!response.ok){
        const err = new Error("Failed to fetch the pay transaction history");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// main function to get transaction history
export async function listPayTransactionHistory(page,page_size,searchTerm,fromDate,toDate,orgFilter) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try{
        return await attemptGetTransactionHistory(page,page_size,accessToken,searchTerm,fromDate,toDate,orgFilter);
    }catch(error){
        if (error.status === 401){
            try{
                const newAccessToken = await refreshAccessToken();
                return await attemptGetTransactionHistory(page, page_size, newAccessToken);
            }catch(refreshError){
                console.log("Token refresh failed",refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error while getting pay transaction history", error?.data || error.message);
        throw error;
    }
}

// transaction history
export async function attemptFetchTransactionHistory(page,page_size,token,searchTerm,fromDate,toDate,orgFilter) {
    console.log("reached here")
    const params = new URLSearchParams({
        page,
        page_size
    })
    console.log(fromDate)
    if (searchTerm) params.append('search',searchTerm)
    if (fromDate) params.append('from_date',fromDate)
    if (toDate) params.append('to_date',toDate)
    if (orgFilter) params.append('org',orgFilter)
    
    const response = await fetch(`${API_URL}/payments/transaction_history/?${params.toString()}`,{
        method:"GET",
        headers:{
            'Authorization': `Bearer ${token}`,
        }
    })

    const responseData = await response.json();

    if(!response.ok){
        const err = new Error("Failed to fetch the pay transaction history");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// main function to get pay transaction history
export async function listTransactionHistory(page,page_size,searchTerm,fromDate,toDate,orgFilter) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try{
        return await attemptFetchTransactionHistory(page,page_size,accessToken,searchTerm,fromDate,toDate,orgFilter);
    }catch(error){
        if (error.status === 401){
            try{
                const newAccessToken = await refreshAccessToken();
                return await attemptFetchTransactionHistory(page, page_size, newAccessToken);
            }catch(refreshError){
                console.log("Token refresh failed",refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error while getting pay transaction history", error?.data || error.message);
        throw error;
    }
}